/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2024, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Accordion, AccordionItem, TextInput } from '@carbon/react';
import cx from 'classnames';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '../../../store';
import { ConfigureContentMessages as messages } from '../../elastic-search/components/messages';
import { ConversationalSearchSection } from '../../ia/components/conversational-search/ConversationalSearchSection';
import { useMilvusDraft } from '../hooks/useMilvusDraft';
import { setDraftFilterValue } from '../store/reducer';
import { selectDraftFilterOptionValue } from '../store/selectors';

import './ConfigureContent.scss';

export interface ConfigureContentProps {
  tabDisplay?: boolean;
  readOnly: boolean;
}
export const ConfigureContent = ({
  tabDisplay = false,
  readOnly
}: ConfigureContentProps) => {
  const draft = useMilvusDraft();
  const dispatch = useDispatch();
  const { formatMessage: t } = useIntl();

  const filter = useAppSelector(selectDraftFilterOptionValue);

  const filterChange = e => {
    const filter = e?.target?.value ?? '';
    // Filter is optional so no validation needed to check that it exists.
    dispatch(setDraftFilterValue(filter));
  };
  return (
    <div
      className={cx('ConfigureContent', { ConfigureContent__tab: tabDisplay })}>
      {tabDisplay && (
        <>
          <Accordion align="start">
            <AccordionItem
              title={t(messages.dropdownAdvancedSettings, { name: 'Milvus' })}>
              <TextInput
                autoComplete="off"
                id="ConfigureContent__form-filter"
                placeholder={t(messages.filterPlaceholder)}
                readOnly={readOnly}
                labelText={t(messages.filter)}
                onChange={filterChange}
                size="md"
                value={filter}
                type="text"
              />
            </AccordionItem>
          </Accordion>
          <ConversationalSearchSection draft={draft} readOnly={readOnly} />
        </>
      )}
    </div>
  );
};
